import { Logo } from '@THC/components/Logo';

import styles from './Footer.module.scss';

export const Footer = () => {
	return (
		<footer className={styles.footer}>
			<div className={styles.footerContent}>
				<div className={styles.companyLogo}>
					<Logo />
				</div>

				<p className={styles.copyright}>© Motorway Online Ltd. 2016-{new Date().getFullYear()}</p>
			</div>
		</footer>
	);
};
